export const getPlacementErrorMessage = (errorCode, details = {}) => {
  const messages = {
    VAL_011:
      "Invalid percentage value. Please select one of the allowed values: 25, 50, 75, or 100.",
    VAL_010: "Invalid date format. Please enter the date in YYYY-MM-DD format.",
    VAL_009:
      "No data available for the selected date range. Please verify the dates and estimation data.",
    VAL_008:
      "Distribution percentages of placements must sum to 100. Please adjust the placement percentages.",
    VAL_007:
      "All placements must have a percentage distribution that totals 100%. Please correct your values.",
    VAL_001:
      "Fractional minutes detected. Allocated hours should be whole numbers. Click 'Yes' to proceed with this allocation.",
    AUTH_001:
      "You don't have permission to perform this action. Only Allocation Admin and Super Admin can add allocations.",
    VAL_002:
      "An allocated employee cannot approve their own timesheets. Please add another approver.",
    VAL_003:
      "Billable hours must be greater than or equal to cost hours. Please adjust your entry.",
    VAL_004:
      "No estimation data found for this allocation. Please verify whether the estimation exists.",
    VAL_005:
      "Cannot update allocation. Timesheets already submitted. Click 'Yes' to delete them or choose another employee",
    VAL_006: `Resource ${
      details.resource_id || "unknown"
    } exceeds daily limit on ${details.date || "unknown date"}. Total hours: ${
      details.total_hours || "unknown"
    }, Limit: ${
      details.limit || "unknown"
    }. Adjust resource allocations accordingly.`,
    VAL_012:
      "There are approved timesheets for the selected placements, so the allocation cannot be updated.",
    VAL_013:
      "There are submitted timesheets for the selected placements. Please click on yes to delete submitted timesheets.",
    VAL_014:
      "An unexpected error occurred. Please try again or contact support.",
    PROC_001: "Failed to create allocation. Check your inputs and try again.",
    PROC_002:
      "Timesheet update failed. Verify the resource ID and allocation details."
  };

  return (
    messages[errorCode] || "An unknown error occurred. Please contact support."
  );
};

export const getDeletePlacementErrorMessage = (errorCode) => {
  const messages = {
    DEL_001: "Change the end_date or talk to support.",
    DEL_002:
      "Get consent from Approver Manager and pass delete_submitted=True.",
    DEL_003: "Provide a valid 'end_date' parameter.",
    DEL_004: "Invalid date format.",
    DEL_005: "End date validation failed.",
    AUTH_001: "Ensure you have the required permissions."
  };

  return (
    messages[errorCode] || "An unknown error occurred. Please contact support."
  );
};

export const getDeleteEmployeeErrorMessage = (errorCode) => {
  const messages = {
    DEL_001:
      "Employee has approved timesheets. Cannot delete until resolved. Contact admin.",
    DEL_002:
      "Employee has submitted timesheets. Click 'Yes' to delete them along with the employee.",
    DEL_003: "Please enter a valid end date to delete the employee.",
    DEL_004: "Invalid end date format. Use YYYY-MM-DD.",
    DEL_005: "Selected end date is invalid for this employee.",
    AUTH_D01: "You don’t have permission to delete this employee",
    AUTH_001: "You must have the required permissions."
  };

  return (
    messages[errorCode] || "An unknown error occurred. Please contact support."
  );
};
